import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';
import { clearSignupOtpSession } from '@utils/signupOtpSession';

type Props = { children: React.ReactNode };

/**
 * Guards signup wizard steps that require an authenticated session:
 * signup-complete, nafath-verification, select-national-address, success.
 * Unauthenticated users are redirected back to /signup and the OTP session is cleared.
 */
export function SignupSessionGuard({ children }: Props) {
  const { lang } = useParams<{ lang: string }>();
  const { isAuthenticated } = useAuth();
  const l = lang === 'ar' ? 'ar' : 'en';

  if (!isAuthenticated) {
    clearSignupOtpSession();
    return <Navigate to={`/${l}/signup`} replace />;
  }

  return <>{children}</>;
}
